export default __webpack_public_path__ + "images/889eeaaeaf99ba5153ae2d8d0ebccb52-travel.jpg";